const Ship = ({ size = 24 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_731_1207)">
        <path
          id="Vector"
          d="M2 19.9995C2.22717 20.316 2.52797 20.5725 2.87642 20.7467C3.22488 20.9209 3.6105 21.0077 4 20.9995C4.3895 21.0077 4.77512 20.9209 5.12358 20.7467C5.47203 20.5725 5.77283 20.316 6 19.9995C6.22717 19.6831 6.52797 19.4266 6.87642 19.2524C7.22488 19.0782 7.6105 18.9914 8 18.9995C8.3895 18.9914 8.77512 19.0782 9.12358 19.2524C9.47203 19.4266 9.77283 19.6831 10 19.9995C10.2272 20.316 10.528 20.5725 10.8764 20.7467C11.2249 20.9209 11.6105 21.0077 12 20.9995C12.3895 21.0077 12.7751 20.9209 13.1236 20.7467C13.472 20.5725 13.7728 20.316 14 19.9995C14.2272 19.6831 14.528 19.4266 14.8764 19.2524C15.2249 19.0782 15.6105 18.9914 16 18.9995C16.3895 18.9914 16.7751 19.0782 17.1236 19.2524C17.472 19.4266 17.7728 19.6831 18 19.9995C18.2272 20.316 18.528 20.5725 18.8764 20.7467C19.2249 20.9209 19.6105 21.0077 20 20.9995C20.3895 21.0077 20.7751 20.9209 21.1236 20.7467C21.472 20.5725 21.7728 20.316 22 19.9995"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M4 18L3 13H21L19 17"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M5 13V7H13L17 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M7 7V3H6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_731_1207">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ship;
